import { computed, ref } from "vue";

const loadingRoute = ref({});
const loadingRouteClears = ref({});
const loadingRequest = ref({});
const loadingRequestClears = ref({});
const loadingRequestSilent = ref({});

export default () => {
	const routeStart = (routeName) => {
		if (!routeName) return false;
		loadingRoute.value[routeName] = true;
		return routeLoadingClearWithDelay(routeName);
	};

	const routeStop = (routeName) => {
		if (!routeName) return false;
		loadingRoute.value[routeName] = false;
		return routeLoadingClearWithDelay(routeName, false);
	};
	const requestStart = (requestUrl) => {
		if (!requestUrl) return false;
		if (loadingRequestSilent.value[requestUrl]) return false;
		loadingRequest.value[requestUrl] = true;
		return requestLoadingClearWithDelay(requestUrl);
	};
	const requestStop = (requestUrl) => {
		if (!requestUrl) return false;
		delete loadingRequest.value[requestUrl];
		delete loadingRequestSilent.value[requestUrl];
		return requestLoadingClearWithDelay(requestUrl, false);
	};
	const requestStopAll = () => {
		Object.keys(loadingRequest).forEach((element) => {
			requestStop(element);
		});
		return true;
	};
	const setRequestSilent = (routeName) => {
		if (!routeName) return false;
		loadingRequestSilent.value[routeName] = true;

		return true;
	};
	const routeLoadingClearWithDelay = (routeName, startTimeout = true, delay = 5000) => {
		if (!routeName) return false;
		if (!window) return false;

		if (loadingRouteClears.value[routeName]) {
			clearTimeout(loadingRouteClears.value[routeName]);
			delete loadingRouteClears.value[routeName];
		}
		if (!startTimeout) return false;

		loadingRouteClears.value[routeName] = setTimeout(() => {
			routeStop(routeName);
		}, delay);

		return true;
	};
	const requestLoadingClearWithDelay = (requestUrl, startTimeout = true, delay = 5000) => {
		if (!requestUrl) return false;
		if (!window) return false;

		if (loadingRequestClears.value[requestUrl]) {
			clearTimeout(loadingRequestClears.value[requestUrl]);
			delete loadingRequestClears.value[requestUrl];
		}
		if (!startTimeout) return false;

		loadingRequestClears.value[requestUrl] = setTimeout(() => {
			requestStop(requestUrl);
		}, delay);

		return true;
	};

	const isLoadingRoute = computed(() => {
		return Object.values(loadingRoute.value).some((element) => element);
	});

	const isLoadingRequest = computed(() => {
		return Object.values(loadingRequest.value).some((element) => element);
	});

	const isLoading = computed(() => {
		return isLoadingRoute.value || isLoadingRequest.value;
	});

	return {
		routeStart,
		routeStop,
		requestStart,
		requestStop,
		requestStopAll,
		setRequestSilent,
		isLoading,
		isLoadingRoute,
		isLoadingRequest,
	};
};
